:root {
  color: #1f2933;
  background: #f7f7f8;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
}

body {
  margin: 0;
}

.app-shell {
  display: grid;
  min-height: 100vh;
  place-items: center;
}

.app-shell h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0;
}
